/**
*
*   Button
*       - Builds the Button Class
*
**/
'use client';
import Button from '@/components/button';
import { useRef, useState } from 'react';
import { useTranslations } from 'next-intl';
import { Swiper, SwiperSlide } from 'swiper/react';

//Build the Element
export default function IconList({ title, data, ...props }){

	const t = useTranslations();

	//Swiper $el reference
	const ref = useRef();

	//Swiper Class
	const [swiper, setSwiper] = useState({
		instance:   null,
		realIndex:  0,
		locked:     false,
		slides:     []
	});

	//Features Object
	const List = {

		data: data,

		//The Swiper Settings
		Swiper: {

			//Params
			slidesPerView:  'auto',
			spaceBetween:   10,
			slidesOffsetBefore: 10,
			slidesOffsetAfter: 10,

			//On Init
			onSwiper:       swiper => setSwiper({
				instance:       swiper,
				localIndex:     swiper.realIndex,
				slides:         swiper.slides,
				locked:         swiper.isLocked
			}),

			//On Slide Change
			onSlideChange: swiper => setSwiper({
				instance:   swiper,
				localIndex: swiper.realIndex,
				slides:     swiper.slides,
				locked:     swiper.isLocked
			}),

			//On Lock (viewport exceeds swiper)
			onLock: swiper => setSwiper({
				instance:   swiper,
				localIndex: swiper.realIndex,
				slides:     swiper.slides,
				locked:     swiper.isLocked
			}),

			//On Unlock (swiper exceeds viewport)
			onUnlock: swiper => setSwiper({
				instance:   swiper,
				localIndex: swiper.realIndex,
				slides:     swiper.slides,
				locked:     swiper.isLocked
			})
		},

		/**
		*
		*   next
		*       - Overrides default swiper to activate each slide
		*
		*   Params:
		*       n/a
		*
		**/
		next: e => {

			//Store Next
			setSwiper({
				instance:   ( swiper.instance ),
				localIndex: ( swiper.localIndex + 1 ),
				slides:     ( swiper.slides )
			});

			//Go to Next
			swiper.instance.slideNext();

		},

		/**
		*
		*   previous
		*       - Overrides default swiper to activate each slide
		*
		*   Params:
		*       n/a
		*
		**/
		previous: e => {

			//Store Next
			setSwiper({
				instance:   ( swiper.instance ),
				localIndex: ( swiper.localIndex - 1 ),
				slides:     ( swiper.slides )
			});

			//Go to previous slide
			swiper.instance.slidePrev();

		},

		/**
		*
		*   goto
		*       - Overrides default swiper to activate a specific slide
		*
		*   Params:
		*       index:      (INT) The index to go to
		*
		**/
		goto: index => {

			//Store Next
			setSwiper({
				instance:   ( swiper.instance ),
				localIndex: index,
				slides:     ( swiper.slides )
			});

			//Go to Next if the swiper instance is accurante, otherwise do nothing
			swiper.instance.slideTo( index );

		}
	};

	return (
		<section className="icon-list container">
			<header>
				<h2>{ title }</h2>
			</header>
			<Swiper {...List.Swiper} className={ `list${ swiper.locked ? ' locked' : '' }`}>{
				List.data.map( ( item , i ) => (
					<SwiperSlide className={ `item ${   i == swiper.localIndex ? 'active' : '' }` } key={ i }>
						<div className="icon">{ item.icon }</div>
						<h2>{ item.name }</h2>
						<p>{ item.content }</p>
					</SwiperSlide>
				))
			}</Swiper>
			<nav>
				<Button onClick={ () => List.previous() } hidden={ swiper.locked || swiper.localIndex == 0 }>
					<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
						<path d="M10.6317 1.81006L18.4803 9.65863L10.6317 17.5072" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
						<path d="M18.4802 9.65869L1.78296 9.65869" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
					</svg>
				</Button>
				<Button onClick={ () => List.next() } hidden={ swiper.locked || swiper.localIndex == ( swiper.slides.length - 1 ) }>
					<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
						<path d="M10.6317 1.81006L18.4803 9.65863L10.6317 17.5072" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
						<path d="M18.4802 9.65869L1.78296 9.65869" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
					</svg>
				</Button>
				<ul className={ swiper.locked ? 'hidden' : '' }>{
					List.data.map( (row,i) => {
						return (
							<li key={ i } className={ ( swiper.localIndex == i ? 'active' : '' ) } onClick={ () => List.goto( i ) }>

							</li>
						);
					})
				}</ul>
			</nav>
		</section>
	);


}